"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ModalAlert = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Modal = _interopRequireDefault(require("../../elements/Modal"));

var _Button = require("../../elements/Button");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ModalAlert = function ModalAlert(props) {
  var isOpen = props.isOpen,
      onBackgroundClick = props.onBackgroundClick,
      heading = props.heading,
      children = props.children,
      onConfirm = props.onConfirm,
      onCancel = props.onCancel,
      cancelLabel = props.cancelLabel,
      confirmLabel = props.confirmLabel,
      isWarning = props.isWarning,
      isError = props.isError,
      isSuccess = props.isSuccess,
      disableConfirm = props.disableConfirm,
      disableCancel = props.disableCancel;
  var modalAlertClassnames = (0, _classnames.default)({
    'modal-alert__content': true,
    'modal-alert__content--warning': isWarning,
    'modal-alert__content--error': isError,
    'modal-alert__content--success': isSuccess
  });
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    isOpen: isOpen,
    onBackgroundClick: onBackgroundClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: modalAlertClassnames
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-alert__heading"
  }, /*#__PURE__*/_react.default.createElement("span", null, heading)), /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-alert__message"
  }, children), /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-alert__buttons"
  }, onCancel && /*#__PURE__*/_react.default.createElement(_Button.ButtonText, {
    classNames: "modal-alert__buttons__cancel",
    onClick: function onClick() {
      onCancel();
    },
    disabled: disableCancel
  }, cancelLabel), /*#__PURE__*/_react.default.createElement(_Button.ButtonLight, {
    classNames: "modal-alert__buttons__confirm",
    onClick: function onClick() {
      onConfirm();
    },
    disabled: disableConfirm
  }, confirmLabel))));
};

exports.ModalAlert = ModalAlert;
ModalAlert.propTypes = {
  onBackgroundClick: _propTypes.default.func.isRequired,
  cancelLabel: _propTypes.default.string.isRequired,
  confirmLabel: _propTypes.default.string.isRequired,
  isOpen: _propTypes.default.bool.isRequired,
  heading: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]).isRequired,
  onConfirm: _propTypes.default.func.isRequired,
  onCancel: _propTypes.default.func,
  disableConfirm: _propTypes.default.bool,
  disableCancel: _propTypes.default.bool,
  isWarning: _propTypes.default.bool,
  isError: _propTypes.default.bool,
  isSuccess: _propTypes.default.bool
};
var defaultProps = {
  cancelLabel: 'Cancel',
  confirmLabel: 'OK',
  onBackgroundClick: function onBackgroundClick() {},
  disableConfirm: false,
  disableCancel: false
};
ModalAlert.defaultProps = defaultProps;
ModalAlert.displayName = 'ModalAlert';
var _default = ModalAlert;
exports.default = _default;